// import ActionType from 'actions/ActionType'

export default (
  state = { label: 'Sample preview contact', value: 'sample' },
  action,
) => {
  const switchObj = {
    'Tasks.SET_MERGE_FIELDS_PREVIEW_SELECT': () => {
      return action.payload
    },
  }

  // If the function returns falsey, a ternary is required because
  // if `|| state` is used, state will remain the same
  return switchObj?.[action?.type] ? switchObj[action?.type]() : state
}
